export default __webpack_public_path__ + "media/images/64-65bce9f3d69dd05e2b1373bd5c107e85.jpg";